// Apoio da tela Uso da IA: nomes e cores das funções, situações e formatação de dinheiro (US$ / R$).

// Uma cor por função, na ordem fixa da paleta categórica (azul, laranja, verde-água, amarelo; a mesma da Análise de
// Atendimento, conferida no validador da skill dataviz em claro e escuro). Contraste abaixo de 3:1 em alguns tons: a
// legenda, o tooltip e as tabelas dão o nome e o número (nunca só a cor).
export const FUNCOES = [
  { codigo: "SUGESTAO_TEXTO", curto: "Sugestão de texto", cor: { light: "#2a78d6", dark: "#3987e5" } },
  { codigo: "RESUMO_HISTORICO", curto: "Resumo do histórico", cor: { light: "#eb6834", dark: "#d95926" } },
  { codigo: "RESUMO_DOCUMENTO", curto: "Resumo de documento", cor: { light: "#1baf7a", dark: "#199e70" } },
  { codigo: "RELATORIO_FRASE", curto: "Relatório por frase", cor: { light: "#eda100", dark: "#c98500" } },
];

export const corDaFuncao = (codigo, darkMode) => {
  const f = FUNCOES.find((x) => x.codigo === codigo);
  return f ? f.cor[darkMode ? "dark" : "light"] : darkMode ? "#b5b4ab" : "#898781";
};

export const nomeCurto = (codigo) => FUNCOES.find((x) => x.codigo === codigo)?.curto || codigo;

export const SITUACOES = {
  OK: { label: "Atendido", cor: "success", dica: "A IA respondeu e a resposta foi usada" },
  DESCARTADO: { label: "Descartado", cor: "warning", dica: "A IA respondeu (com custo), mas a resposta não serviu (ex.: a sugestão perdeu um dado protegido); não conta no limite do dia" },
  ERRO: { label: "Erro", cor: "error", dica: "A IA não respondeu (chave recusada, sem crédito, tempo esgotado...)" },
  BLOQUEADO: { label: "Barrado", cor: "secondary", dica: "Não foi à IA: função desligada, limite do dia ou teto do mês" },
  REAPROVEITADO: { label: "Reaproveitado", cor: "info", dica: "Resumo já feito, mostrado de novo sem chamar a IA (sem custo)" },
};

const numeroBr = (v, casas) => new Intl.NumberFormat("pt-BR", { minimumFractionDigits: casas, maximumFractionDigits: casas }).format(v);

/** US$ com 2 casas; abaixo de 1 centavo (pedidos soltos custam frações de centavo), 4. */
export function usd(valor) {
  if (valor === null || valor === undefined || Number.isNaN(Number(valor))) return "-";
  const v = Number(valor);
  return `US$ ${numeroBr(v, v !== 0 && Math.abs(v) < 0.01 ? 4 : 2)}`;
}

/** R$ pela cotação da tela; sem cotação, nada. */
export function brl(valor, cotacao) {
  if (valor === null || valor === undefined || !cotacao) return null;
  const v = Number(valor) * Number(cotacao);
  return `R$ ${numeroBr(v, v !== 0 && Math.abs(v) < 0.01 ? 4 : 2)}`;
}

export const dinheiro = (valor, cotacao) => {
  const r = brl(valor, cotacao);
  return r ? `${usd(valor)} (${r})` : usd(valor);
};

/** O trecho da chave que a OpenAI mostra vem com ~150 asteriscos no meio ("sk-svcac****k7AA"): fica "sk-svcac...k7AA". */
export const trechoDaChave = (texto) => (texto ? texto.replace(/[*.…]{3,}/g, "...") : texto);

/** Tokens: inteiro com milhar; a partir de 1 milhão, "1,2 mi". */
export function tokens(n) {
  const v = Number(n || 0);
  if (v >= 1_000_000) return `${numeroBr(v / 1_000_000, 1)} mi`;
  return numeroBr(v, 0);
}
